import requests from "../util";
const { request } = requests;
const fetchGetAllCategories = (pageNum, pageSize, searchName) => {
  const params = {
    pageNum,
    pageSize,
    ...(searchName && { searchName }),
  };
  return request({
    url: "/api/v1/category",
    method: "get",
    params,
  });
};
const fetchGetAllSubCategories = (category, pageNum, pageSize, searchName) => {
  if (!category) {
    return null;
  }
  const params = {
    category,
    pageNum,
    pageSize,
    ...(searchName && { searchName }),
  };
  return request({
    url: "/api/v1/subCategory",
    method: "get",
    params,
  });
};
const createNewCategory = (payload) => {
  return request({
    url: "/api/v1/category",
    method: "post",
    body: payload,
  });
};
const createNewSubCategory = (payload) => {
  return request({
    url: "/api/v1/subCategory",
    method: "post",
    body: payload,
  });
};

const getCategoryPresignedUrl = async ({ filename, mimeType }) => {
  const params = {
    filename,
    mimeType,
  };

  return request({
    url: "/api/v1/category/presignedUrl",
    method: "get",
    params,
  });
};

const getSubCategoryPresignedUrl = async ({ filename, mimeType }) => {
  const params = {
    filename,
    mimeType,
  };

  return request({
    url: "/api/v1/subCategory/presignedUrl",
    method: "get",
    params,
  });
};

const getMarketPlacePresignedUrl = async ({ filename, mimeType }) => {
  const params = {
    filename,
    mimeType,
  };

  return request({
    url: "/api/v1/marketplace/presignedUrl",
    method: "get",
    params,
  });
};

const getAnglePresignedUrl = async ({ filename, mimeType }) => {
  const params = {
    filename,
    mimeType,
  };

  return request({
    url: "/api/v1/angle/presignedUrl",
    method: "get",
    params,
  });
};

const getThumbPathOfImage = async ({ key }) => {
  return request({
    url: "/api/v1/util/createThumbnail",
    method: "post",
    body: { key },
  });
};
const createNewAngle = (payload) => {
  return request({
    url: "/api/v1/angle",
    method: "post",
    body: payload,
  });
};
const createNewMarketPlace = (payload) => {
  return request({
    url: "/api/v1/marketplace",
    method: "post",
    body: payload,
  });
};
const fetchGetAllAngles = (category, subCategory, orgId, pageNum, pageSize) => {
  const params = {
    category: category,
    subCategory: subCategory,
    orgId: orgId,
    pageNum: pageNum,
    pageSize: pageSize,
  };
  return request({
    url: "/api/v1/angle",
    method: "get",
    params,
  });
};

const fetchGetAllMarketPlace = (orgId, pageNum, pageSize) => {
  const params = {
    orgId,
    pageNum,
    pageSize,
  };
  return request({
    url: "/api/v1/marketplace",
    method: "get",
    params,
  });
};

const fetchGetAllMarketPlaceCategories = (marketplace, orgId) => {
  if (!marketplace || orgId === "") {
    return null;
  }

  const params = { marketplace };
  if (orgId !== null) {
    params.orgId = orgId;
  }
  return request({
    url: "/api/v1/marketplace/listCategories",
    method: "get",
    params,
  });
};

const fetchGetAllMarketPlaceSubCategories = (category, marketplace, orgId) => {
  if (!marketplace || !category || orgId === "") {
    return null;
  }
  const params = { category, marketplace };
  if (orgId !== null || orgId !== "") {
    params.orgId = orgId;
  }
  return request({
    url: "/api/v1/marketplace/listSubCategories",
    method: "get",
    params,
  });
};

const addCategoryToMarketPlace = (payload) => {
  return request({
    url: "/api/v1/marketplace/addCategoryToMarketplace",
    method: "post",
    body: payload,
  });
};

const addSubCategoryToMarketPlace = (payload) => {
  return request({
    url: "/api/v1/marketplace/addSubCategoryToMarketplace",
    method: "post",
    body: payload,
  });
};

const fetchGetAllMergedGuidelines = (category, subCategory, marketplace) => {
  if (!category || !subCategory || !marketplace) {
    return null;
  }
  const params = {
    category,
    subCategory,
    marketplace,
  };
  return request({
    url: "/api/v1/guideline/getMergedGuideline",
    method: "get",
    params,
  });
};
const fetchGuidelineData = (guidelineId) => {
  return request({
    url: `/api/v1/guideline/${guidelineId}`,
    method: "get",
  });
};
const addAngleSetToMarketPlace = (payload) => {
  return request({
    url: "/api/v1/marketplace/addAngleSetToMarketplace",
    method: "post",
    body: payload,
  });
};
const updateAngleSetToMarketPlace = (payload) => {
  return request({
    url: "/api/v1/marketplace/updateAngleSetOfMarketplace",
    method: "post",
    body: payload,
  });
};
const deleteAngleSet = (payload) => {
  return request({
    url: "/api/v1/marketplace/deleteAngleSetFromMarketplace",
    method: "post",
    body: payload,
  });
};
const createDuplicateAngleSet = (payload) => {
  return request({
    url: "/api/v1/guideline/cloneAngleSetOnGuideline",
    method: "post",
    body: payload,
  });
};
const fetchAllAngleListShootTypes = (marketplace) => {
  return request({
    url: "/api/v1/angle/listShootTypes",
    method: "get",
  });
};

const fetchAllOrganization = (pageNum, pageSize) => {
  return request({
    url: "/api/v1/organization",
    method: "get",
  });
};

const fetchPendingRequests = (pageNum, pageSize, requestType) => {
  const params = {
    pageNum,
    pageSize,
    requestType,
  };

  return request({
    url: "/api/v1/request",
    method: "get",
    params,
  });
};

const markUnderReview = (payload) => {
  return request({
    url: `/api/v1/request/markUnderReview`,
    method: "patch",
    body: payload,
  });
};

const skuGuidelineDetails = (skuId, pageNum, pageSize) => {
  if (!skuId) {
    return null;
  }

  const params = {
    pageNum,
    pageSize,
  };

  return request({
    url: `/api/v1/sku/guideline?skuId=${skuId}`,
    method: "get",
    params,
  });
};
const getUrlFromKey = async ({ key }) => {
  return request({
    url: "/api/v1/util/getUrlFromKey",
    method: "post",
    body: { key },
  });
};
const guidelinesApi = {
  fetchGetAllCategories,
  fetchGetAllSubCategories,
  createNewCategory,
  createNewSubCategory,
  getCategoryPresignedUrl,
  getSubCategoryPresignedUrl,
  getMarketPlacePresignedUrl,
  getAnglePresignedUrl,
  getThumbPathOfImage,
  createNewAngle,
  fetchGetAllAngles,
  createNewMarketPlace,
  fetchGetAllMarketPlace,
  fetchGetAllMarketPlaceCategories,
  fetchGetAllMarketPlaceSubCategories,
  addCategoryToMarketPlace,
  addSubCategoryToMarketPlace,
  fetchGetAllMergedGuidelines,
  addAngleSetToMarketPlace,
  deleteAngleSet,
  fetchAllAngleListShootTypes,
  fetchGuidelineData,
  updateAngleSetToMarketPlace,
  fetchAllOrganization,
  fetchPendingRequests,
  markUnderReview,
  createDuplicateAngleSet,
  skuGuidelineDetails,
  getUrlFromKey,
};

export default guidelinesApi;
